import { useContext, useEffect, useMemo, useState } from "react"
import { formJson } from "../../../utils/formJson";
import { useCommanKit } from "./useCommanKit";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";

export const useProvidentNomination = ({ label, data }) => {
    const { showSuccess, showError } = useContext(ToastContext)
    const { fieldData, getDataKey } = formJson?.[label];
    const { getEmployeeDetails } = useCommanKit({ data });
    const [formValues, setFormValues] = useState({});
    const [familyData, setFamilyData] = useState(null);
    const [showPopup, setShowPopup] = useState({
        visibel: false,
        section: "",
        row: ""
    })

    useEffect(() => {
        callAPI("user_family_details")
        callAPI(getDataKey)
    }, [data?.employee]);


    const callAPI = (key) => {
        data?.employee?.user_code && getEmployeeDetails(key, data?.employee?.user_code).then((res) => {
            Object.entries(fieldData).forEach(([sectionName, sectionObj]) => {
                if (key === "user_family_details") {
                    const data = res?.user_family_details?.map(item => ({
                        label: item.member_name,
                        value: item?.family_id
                    }));
                    setFamilyData(data)

                } else {
                    setFormValues((prev) => {
                        const data = res?.[sectionObj.key] || [];
                        return {
                            ...prev,
                            [sectionName]: data,
                        };

                    });
                }
            })
        })
    }

    function nomineeTable(nominees) {
        return nominees?.reduce((acc, curr) => acc + Number(curr.nominee_percentage), 0);
    }

    const handleDelete = async (section, row) => {
        try {
            const payload = {
                "attribute_item_delete_key": fieldData[section]["deleteKey"],
                "education_id": row?.education_id || 0,
                "family_id": 0,
                "language_id": row?.language_id || 0,
                "reference_id": row?.reference_id || 0,
                "experience_id": row?.experience_id || 0,
                "insurance_nomination_id": row?.insurance_nomination_id || 0,
                "efp_nomination_id": row?.efp_nomination_id || 0,
                "eps_nomination_id": row?.eps_nomination_id || 0,
                "esic_nominee_id": row?.esic_id || 0,
                "esic_witness_id": row?.esic_id || 0,
                "esic_family_insured_id": row?.esic_family_insured_id || 0,
                "esic_nominee_details_id": row?.esic_id ||0
            }
            const res = await services.getInvokeRemote("POST", Urls("DELETEEMPLOYEEDETAILSREMOVE"), payload)
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
                setShowPopup({ visibel: false, section: "", row: "" })
                callAPI(getDataKey)
            } else {
                showError("error", res?.body?.errorMessage);
            }
        } catch (error) {
            console.error(error)
        }

    };

    return useMemo(() => ({
        fieldData, formValues, nomineeTable, handleDelete, callAPI, showPopup, setShowPopup, familyData
    }), [fieldData, formValues, nomineeTable, handleDelete, callAPI, showPopup, setShowPopup, familyData])
}